import React, { useState } from "react";
import { useQuery } from "@apollo/client";

import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Switch from "@mui/material/Switch";
import Skeleton from "@mui/material/Skeleton";

import ChangeSafetyEventsDialog from "./ChangeSafetyEventsDialog";
import { GPS_LIVE_INTEGRATION_QUERY } from "./query";

const IntegrationPanel = () => {
  const [open, setOpen] = useState(false);
  const { loading, data } = useQuery(GPS_LIVE_INTEGRATION_QUERY, {
    fetchPolicy: "cache-and-network",
  });

  const checked = Boolean(data?.integrations?.gpsLive?.safetyEventsEnabled);

  return (
    <>
      <Card>
        <CardHeader
          avatar={
            <Avatar
              alt="GPS Live"
              src={`${process.env.PUBLIC_URL}/icons/gpslive-logo-512x512.png`}
            />
          }
          title="GPS Live"
          subheader="Store GPS Live driver behaviour events as safety events"
        />
        <CardContent>
          {loading && !data ? (
            <Skeleton width="40%" />
          ) : (
            <>
              Store events as safety events
              <Switch
                checked={checked}
                onChange={() => setOpen(true)}
                name="gpsLiveSafetyEvents"
              />
            </>
          )}
        </CardContent>
      </Card>
      <ChangeSafetyEventsDialog
        open={open}
        handleClose={() => setOpen(false)}
        checked={checked}
      />
    </>
  );
};

export default IntegrationPanel;
